module.exports = __webpack_public_path__ + "static/img/Ok.385bb89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Ok.png
// module id = dEcv
// module chunks = 0